import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DataEntity} from 'octopus-connect';
import {GlobalConfigurationService} from 'fuse-core/services/global-configuration.service';

@Component({
    selector: 'app-activty-card',
    templateUrl: './activty-card.component.html',
    styleUrls: ['./activty-card.component.scss'],
    standalone: false
})
export class ActivtyCardComponent implements OnInit {

    @Input() isActivitiesIsDone: boolean;

    @Input() title: string;

    @Input() image: string;

    @Input() subLesson: DataEntity;

    @Input() i: number;

    @Output() playEvent = new EventEmitter<{ subLesson: DataEntity, i: number }>();

    constructor(public globalConfigurationService: GlobalConfigurationService) {
    }

    ngOnInit(): void {
    }

    play(subLesson, i) {
        this.playEvent.emit({subLesson, i});
    }
}
